import React from "react";
import { ImageContainer } from "web/react/emo/image-container/index";

interface MediaCardProps {
    image: string;
    url?: string;
    caption?: string | null;
    sendClickEvent: (action: string) => void;
}

export function MediaCard({
    image,
    url,
    caption,
    sendClickEvent,
}: MediaCardProps): React.ReactElement {
    return (
        <a href={url} onClick={() => sendClickEvent("image")} data-testid="media-card">
            <ImageContainer
                imageSrc={image}
                imageCredit={caption || null}
                textStyle={{ sm: "caption-3-small", md: "caption-3-small", lg: "caption-3" }}
            />
        </a>
    );
}
